import { george, pr, theme } from "aaa";
import { ui } from "components/util/uiHelpers";
import { FormattedHTMLMessage } from "i18n/util";
import { observer } from "mobx-react";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { GooglePayRoutes } from "./GooglePayRoutes";
import { GooglePayStore } from "./GooglePayStore";

const labelStyle: React.CSSProperties = { wordBreak: "normal" };

export const GooglePaySummary = observer(({ store }: { store: GooglePayStore }) => {
    const PageComponent = externalInterfaceStore.isGeorgeApp ? george.PageWithActionButton : React.Fragment;

    const handleSubmit = async () => {
        try {
            await store.postGooglePayApproval();
            pushRoute(GooglePayRoutes.SIGNING);
        } catch (error) {
            pushRoute("/error");
        }
    };

    return (
        <george.Background>
            <PageComponent>
                <george.Card style={{ marginBottom: theme.MARGIN_SMALL }}>
                    <div style={{ padding: theme.MARGIN }}>
                        <george.SectionTitle style={{ marginTop: 0 }}>
                            {ui.__("common.summary")}
                        </george.SectionTitle>
                        <pr.LightSeparatorLine spacing={theme.MARGIN} />
                        <george.ResponsiveSummaryElement label={ui.__("signing.action.label")} labelStyle={labelStyle}>
                            <pr.SigningLabel>
                                {ui.__("googlePay.summary.action.description")}
                            </pr.SigningLabel>
                        </george.ResponsiveSummaryElement>
                    </div>
                    <pr.LightSeparatorLine spacing={theme.MARGIN} />
                    <div style={{ padding: theme.MARGIN }}>
                        <pr.P_16_CONTENT>
                            <FormattedHTMLMessage id="googlePay.summary.approval" />
                        </pr.P_16_CONTENT>
                    </div>
                    {!externalInterfaceStore.isGeorgeApp &&
                        <pr.LightSeparatorLine spacing={theme.MARGIN} />
                    }
                    <george.ActionButton
                        messageId="loan.summary.actionSign"
                        onClick={handleSubmit}
                        isLoading={store.isLoading}
                        primary
                        {...george.getActionButtonWebVersionProps()}
                    />
                </george.Card>
            </PageComponent>
        </george.Background>
    );
});


// WEBPACK FOOTER //
// ./src/components/googlePay/GooglePaySummary.tsx